import { MenuComponent } from './../menu/menu.component';
import { HelpModalComponent } from './../../questionnaire/help-modal/help-modal.component';
import { Component, Input, OnInit } from '@angular/core';
import { ModalController, PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent  {
  @Input() hasHelpButton = false;
  @Input() tagline = 'Orientando';
  @Input() marginLeftClass = 'ml-0';


  constructor(public modalController: ModalController, private popoverController: PopoverController) { }

  async showMenu(event) {
    const popover = await this.popoverController.create({
      component: MenuComponent,
      cssClass: 'menuPopup',
      event,
    });
    await popover.present();
    return await popover.present();
  }


  async showHelpModal() {
    const modal = await this.modalController.create({
      component: HelpModalComponent
    });
    return await modal.present();
  }
}
